import CandidatePerJobPost from "@Organism/Home/Business/Dashboard/CandidatePerJobPost";
import LoadingAnimationPage from "@Organism/LoadingAnimationPage";
import AsyncErrorBoundary from "@Organism/Utils/AsyncErrorBoundary";
import { getCandidatePerJobPostingClient } from "@Services/home";
import { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";

export const loaderCandidatePerJobPost = (route) => {
  const url = new URL(route?.request?.url);
  const { id } = route?.params;
  const query = url.searchParams;
  const pages = +query?.get("p") || 1;
  const limit = +query?.get("l") || 10;
  const search = query?.get("s") || "";

  return defer({
    getCandidatePerJobPostingClient: getCandidatePerJobPostingClient(
      id,
      limit,
      pages,
      search
    ),
  });
};

export default function CandidatePerJobPostPage() {
  const { getCandidatePerJobPostingClient } = useLoaderData();

  return (
    <Suspense fallback={<LoadingAnimationPage />}>
      <Await
        resolve={getCandidatePerJobPostingClient}
        errorElement={
          <div
            style={{
              height: "calc(100vh - 60px)",
            }}
          >
            <AsyncErrorBoundary />
          </div>
        }
      >
        {(getCandidatePerJobPostingClient) => (
          <CandidatePerJobPost data={getCandidatePerJobPostingClient} />
        )}
      </Await>
    </Suspense>
  );
  // return <CandidatePerJobPost />;
}
